export var TARIFF_GROUP = {
  homeInternet: 'homeInternet',
  homeInternetAndTv: 'homeInternetAndTv',
  homeInternetTvAndMobile: 'homeInternetTvAndMobile',
  presetUp: 'presetUp'
};
export var PRESET_FORM_BASE_URL = '/customers/products/mobile/convorder';
export var DEVICE_TAB_TYPE = {
  deviceDocumentation: 3,
  deviceInformation: 1,
  deviceParameters: 2
};
export var DEVICE_CARD_SIZE = {
  large: 'large',
  medium: 'medium',
  small: 'small'
};
export var DEVICE_TYPE = /*#__PURE__*/function (DEVICE_TYPE) {
  DEVICE_TYPE["router"] = "router";
  DEVICE_TYPE["tvConsole"] = "tvConsole";
  return DEVICE_TYPE;
}({});
export var PAGE_TYPE_EVENT_NAMES = {
  fmc: 'fmc_page_ev_',
  fttb_kit: 'fttb-kit_page_ev_',
  fttb_net: 'fttb-net_page_ev_'
};
export var PAGE_TYPES = {
  fmc: 'fmc'
};
export var FttbBlocks = {
  ARTICLES: 'reviews',
  ADDITIONAL_INFO: 'additionalInfo',
  ADDITIONAL_SERVICES: 'additionalServices',
  ADVANTAGES_CARDS: 'advantagesWidget',
  BANNER: 'mainBanner',
  CHECK_ADDRESS: 'checkAddress',
  CONNECTION_CARDS: 'aboutConnectionWidget',
  DEVICES: 'equipment',
  FAQ: 'faq',
  HEADING: 'header',
  HOME_TARIFFS_BANNER: 'homeTariffsBanner',
  INFO_CARDS: 'mainWidget',
  LEAVE_PHONE: 'connectionFeedback',
  NEWS: 'news',
  QUIZ: 'game',
  TARIFFS: 'tariffs2022'
};
export var DEVICE_PAYMENT_TYPE = {
  available: 'available',
  preEnabled: 'preEnabled'
};
export var VkGoalEvent = {
  shpdInitiateAddress: 'shpd_initiate_address',
  shpdInitiateCallback: 'shpd_initiate_callback',
  shpdInitiateNotAddress: 'shpd_initiate_notaddress',
  shpdLead: 'shpd_lead',
  shpdOpenForm: 'shpd_open_form',
  shpdOrderedACall: 'shpd_ordered_a_call',
  shpdOrderedCallback: 'shpd_ordered_callback',
  shpdTvIntInitiateCheckout: 'shpd_tv_int_initiate_checkout',
  shpdTvIntOpenForm: 'shpd_tv_int_open_form',
  shpdTvIntPurchase: 'shpd_tv_int_purchase',
  shpdTvLead: 'shpd_tv_lead',
  shpdTvOpenForm: 'shpd_tv_open_form'
};
export var PAGE_TYPE = {
  fttb_net: 'fttb-net',
  fttb_kit: 'fttb-kit'
};